import React, { useEffect, useState } from "react";
import ReBiddingDialog from "../../molecules/ReBiddingDialog";
import Button from "../../atoms/Button";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { counterofferAcceptPostApi } from "../../../utils/API/counterofferAccept";
import { counterofferRejectPostApi } from "../../../utils/API/counterofferReject";
import { useDispatch } from "react-redux";
import { taxationAmount } from "../../../utils/API/taxationAmount";
const CounterOfferDialog = ({
  open,
  onOk,
  onCancel,
  onCounterBidClick,
  onAcceptBidClick,
  onRejectBidClick,
  selectedRowData,
  selectedColumns,
  bidId,
}) => {
  const dispatch = useDispatch();
  const [amount, setAmount] = useState(0);
  const [gst, setGst] = useState(0);
  const [platformFee, setPlatformFee] = useState(0);
  const [remittance, setRemittance] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const navigate = useNavigate();
  if (!selectedRowData) {
    return null;
  }

  const previousNoOfCredits = selectedRowData["No. of credits"];
  const previousPricePerCredit = selectedRowData["Bid Price"];
  const counteredCredits = selectedRowData["Countered Credits"];
  const counteredPrice = selectedRowData["Countered Price"];

  const handleAcceptCounter = async () => {
    // console.log(counteredCredits);
    // console.log(counteredPrice);
    try {
      const response = await counterofferAcceptPostApi(
        {
          bidId: bidId,
          counterBidAmount: counteredCredits,
          counterBidCredits: counteredPrice,
        },
        dispatch
      );
      // console.log("Response is :", response.data._id);
      const transactionId = response.data._id;
      // navigate(`/order-summary?bidId=${bidId}&transactionId=${transactionId}`);
      onAcceptBidClick();
    } catch (error) {
      console.error("Error during Accepting Counter Offer:", error.message);
    }
  };
  const handleRejectCounter = async () => {
    try {
      const response = await counterofferRejectPostApi(
        {
          bidId: bidId,
          counterBidAmount: counteredPrice,
          counterBidCredits: counteredCredits,
        },
        dispatch
      );
      onRejectBidClick();
    } catch (error) {
      console.error("Error during Rejecting Counter Offer:", error.message);
    }
  };

  const fetchTaxationData = async () => {
    try {
      const formData = {
        buyerOrigin: "NAT",
        sellerOrigin: "NAT",
        totalAmount: previousNoOfCredits * previousPricePerCredit,
      };
      const amounts = await taxationAmount(formData, dispatch);
      setAmount(formData.totalAmount);
      setGst(amounts.data.data.tax);
      setPlatformFee(amounts.data.data.platform_fee);
      setRemittance(amounts.data.data.remittance);
      const calculatedTotalAmount =
        formData.totalAmount +
        amounts.data.data.tax +
        amounts.data.data.platform_fee +
        amounts.data.data.remittance;
      setTotalAmount(calculatedTotalAmount);
    } catch (error) {
      toast.error("Error in Fetching Taxes and amounts Balance");
    } finally {
    }
  };
  // eslint-disable-next-line
  useEffect(() => {
    fetchTaxationData();
  }, [selectedRowData]);

  return (
    <ReBiddingDialog
      open={open}
      title={"Counter Offer Recieved"}
      onCancel={onCancel}
      onOk={onOk}
      selectedRowData={selectedRowData}
      selectedColumns={selectedColumns}
    >
      <div className="">
        <div className="flex pt-2 pr-10 text-base pb-2 gap-x-12 ">
          <div className="w-48 pl-10 mr-[-0.2rem] font-bold ">Your Bid-</div>
          <div className="flex gap-x-32 ">
            <div>No of Credits - {previousNoOfCredits}</div>
            <div>Price per credit - ${previousPricePerCredit}</div>
          </div>
        </div>

        <div className="flex font-bold pt-2 pr-10 text-base bg-blue-400  ">
          <div className="w-60 pl-10 ">Seller's Counter bid-</div>
          <div className="flex  gap-x-20 ">
            <div>No of Credits - {counteredPrice} </div>
            <div className="pl-4">Price per credit - ${counteredCredits}</div>
          </div>
        </div>
        <div className=" pt-3 pl-12 text-xs text-gray-400">
          <p className="py-1">Amount = ${amount?.toFixed(2)}</p>
          <p className="pb-1">Tax(GST) = ${gst?.toFixed(2)}</p>
          <p className="pb-1">Remittance = ${remittance?.toFixed(2)}</p>
          <p className="pb-1">Platform Fee = ${platformFee?.toFixed(2)}</p>
        </div>
        <p className="pl-12 text-sm">
          Total Fund Required - ${totalAmount?.toFixed(2)}
        </p>
      </div>
      <div className="flex justify-center gap-5">
        <Button
          varient="primary"
          borderColor="blue"
          className=" w-40 h-10 mt-4  mb-7 text-sm justify-center lg:py-2 text-blue-800 font-bold border-none  bg-blue-200   "
          onClick={onCounterBidClick}
        >
          Counter
        </Button>
        <Button
          varient="primary"
          borderColor="blue"
          className=" w-40 h-10 mt-4  mb-7 text-sm justify-center lg:py-2 text-white font-bold border-none  bg-blue-800 "
          onClick={() => handleAcceptCounter()}
        >
          Accept
        </Button>
        <Button
          varient="primary"
          borderColor="blue"
          className=" w-40 h-10 mt-4  mb-7 text-sm justify-center lg:py-2 text-red-700 font-bold border-none  bg-red-600 bg-opacity-30  "
          onClick={() => handleRejectCounter()}
        >
          Reject
        </Button>
      </div>
    </ReBiddingDialog>
  );
};

export default CounterOfferDialog;
